export const customFilterTypes = {
    inlist: (rows: any, id: any, filterValue: any) => {
  
      return rows.filter((row: any) => {
        const entry = row.values[id];
  
        if(entry === undefined) {
          return true;
        }
  
        if(Array.isArray(entry)) {
  
          var exists = entry.some((item) => {
  
            if(item?.name !== undefined) {
              if(String(item.name) === filterValue) {
                return true;
              }
            }
          });
          
          return exists;
        }
        else {
          return false;
        }
      })
  
    }
  }